import React from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { RecipeImage as Image, MenuRecipeImage } from '@library/menu-service'

import { getBrowserType } from 'selectors/browser'
import { getFeaturedImage, getRangeImages } from 'utils/image'

import { DetailCarousel } from '../Carousel'
import { DetailImage } from '../DetailImage'

type RecipeImageProps = {
  title: string
  isFineDineIn: boolean
  images: {
    partial?: Image[]
    full?: MenuRecipeImage[]
  }
}

const ImageContainer = withCitrusTheme(Box, (theme) => ({
  marginLeft: `-${theme.spacing(4)}px`,
  marginTop: `-${theme.spacing(4)}px`,
  width: `calc(100% + 2*${theme.spacing(4)}px)`,
  [`@media (min-width: ${theme.tokens.breakpoints[0]})`]: {
    marginLeft: `-${theme.spacing(6)}px`,
    marginTop: `-${theme.spacing(6)}px`,
    width: `calc(100% + 2*${theme.spacing(6)}px)`,
  },
}))

export const RecipeImage = ({ isFineDineIn, images, title }: RecipeImageProps) => {
  const { partial: partialImages, full: fullImages } = images
  const browserType = useSelector(getBrowserType)

  const view = isFineDineIn ? 'fineDineInDetail' : 'detail'

  if (!isFineDineIn) {
    const featuredImage = getFeaturedImage(partialImages, 'detail', browserType)

    return (
      <ImageContainer>
        <DetailImage media={featuredImage} title={title} view={view} />
      </ImageContainer>
    )
  }

  const featuredFullImage = getFeaturedImage(fullImages, 'detail', browserType)
  const rangeImages = getRangeImages(fullImages)

  return (
    <ImageContainer>
      <DetailCarousel images={rangeImages} fallbackImage={featuredFullImage} />
    </ImageContainer>
  )
}
